import { get, post, del } from "../../httpService";

export const retrieveEmotionTypes = () => get("/life-events/emotion-types");
export const retrieveEventCategories = () => get("/event-category");
export const retrieveEvents = (userId) => get(`/life-events/${userId}`);
export const addLifeEvent = (userId, event) => post(`/life-events/${userId}`, event);
export const deleteLifeEvent = (userId, eventId) => del(`/life-events/${userId}/events/${eventId}`);
